import { useEffect, useRef, useState } from 'react'
import { useOutsideClickForTwoRef } from '../../../../../Hooks/useOutsideClickForTwoRef';
import ChevronDown from '../../../../../Assets/ChevronDownLargeDarkMode.svg';
import TickMark from '../../../../../Assets/Modals/TickMark.svg';
import { getCollectionForCategory } from '../../../../../lib/utils/apiCalls';

function CollectionDropdown({ category, selectedCollections, updateSelectedCollections }) {
    const collectionDropdownButtonRef = useRef(null);
    const collectionDropdownRef = useRef(null);

    useOutsideClickForTwoRef(collectionDropdownButtonRef, collectionDropdownRef, () => {
        setCollectionDropdownOpen(false);
    });

    const [collection, setCollection] = useState([]);

    const [collectionDropdownOpen, setCollectionDropdownOpen] = useState(false);

    const [names, setNames] = useState([]);

    const handleCollectionDropdownItemClick = (e, collection) => {
        e.stopPropagation();

        let isSelected = selectedCollections.some(selected => selected.id === collection.id);

        if(isSelected) {
            let filteredList = selectedCollections.filter(item => item.id !== collection.id);
            updateSelectedCollections(filteredList);
        }
        else {
            updateSelectedCollections([ ...selectedCollections, collection]);
        }
    }

    const toggleCollectionDropdown = () => {
        setCollectionDropdownOpen(!collectionDropdownOpen);
    }

    useEffect(() => {
        const fetchCollections = async () => {
            try {
                const response = await getCollectionForCategory(category.id);
                setCollection(response.collection);
            }
            catch(err) {
                console.log(err);
            }
        }

        fetchCollections();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let arr = collection.filter(collectionItem => selectedCollections.some(selected => selected.id === collectionItem.id))
        .map(collectionItem => collectionItem.CollectionName);

        setNames(arr);
    }, [selectedCollections, collection]);

    return (
        <div className="flex flex-col gap-2">
            <h1 className='select-none cursor-pointer font-medium text-base text-[#121212]'>{category.categoryName} Collection</h1>

            <div ref={collectionDropdownButtonRef} onClick={toggleCollectionDropdown} className="relative cursor-pointer px-3 py-4 border rounded-[9px] border-[#EAEAEA] bg-[#F5F5F5] flex items-center gap-[10px]">
                <div className="w-[calc(100%-24px)]">
                    <p className='font-normal select-none text-base text-[#666666] whitespace-nowrap overflow-hidden text-ellipsis'>
                        {names.length > 0 ? names.map(item => item).join(', ') : 'Select'}
                    </p>
                </div>

                <div className="w-6 h-6 flex items-center justify-center select-none">
                    <img src={ChevronDown} alt="" />
                </div>

                {
                    collectionDropdownOpen && 
                    <div ref={collectionDropdownRef} className="absolute bg-[#FFFFFF] max-h-56 overflow-y-scroll z-10 top-14 left-0 w-full border border-[#EAEAEA] rounded-xl overflow-hidden shadow-[0px_0px_12px_0px_#0000003D]">
                        {collection.map(collection => {
                            let isSelected = selectedCollections.some(selected => selected.id === collection.id);

                            return (
                                <div key={collection.id} onClick={(e) => handleCollectionDropdownItemClick(e, collection)} className="w-full px-3 py-4 flex gap-[10px] bg-[#FFFFFF] hover:bg-[#F5F5F5]">
                                    <div className={`w-6 h-6 cursor-pointer rounded-md ${isSelected ? 'border-none bg-primaryColor flex items-center justify-center' : 'border border-[#D1D5DB]'} `}>
                                        <img src={isSelected ? TickMark : undefined} alt="" />
                                    </div>

                                    <p className='font-medium select-none text-base text-[#666666]'>
                                        {collection.CollectionName}
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                }
            </div>
        </div>
    );
}

export default CollectionDropdown;
